/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum PermissionType {
  ADMIN_ORGANIZATION = "admin:organization",
  CREATOR_RAW_MATERIAL = "creator:raw_material",
  EDITOR_RAW_MATERIAL = "editor:raw_material",
  VIEWER_RAW_MATERIAL = "viewer:raw_material",
  CREATOR_RAW_MATERIAL_BATCH = "creator:raw_material_batch",
  EDITOR_RAW_MATERIAL_BATCH = "editor:raw_material_batch",
  VIEWER_RAW_MATERIAL_BATCH = "viewer:raw_material_batch",
  CREATOR_RAW_MATERIAL_COMPARISON = "creator:raw_material_comparison",
  EDITOR_RAW_MATERIAL_COMPARISON = "editor:raw_material_comparison",
  VIEWER_RAW_MATERIAL_COMPARISON = "viewer:raw_material_comparison",
  CREATOR_RAW_MATERIAL_ANNOTATION = "creator:raw_material_annotation",
  EDITOR_RAW_MATERIAL_ANNOTATION = "editor:raw_material_annotation",
  VIEWER_RAW_MATERIAL_ANNOTATION = "viewer:raw_material_annotation",
  CREATOR_FORMULA = "creator:formula",
  EDITOR_FORMULA = "editor:formula",
  VIEWER_FORMULA = "viewer:formula",
  CREATOR_DOCUMENT = "creator:document",
  EDITOR_DOCUMENT = "editor:document",
  VIEWER_DOCUMENT = "viewer:document",
  CREATOR_SUBSTANCE = "creator:substance",
  EDITOR_SUBSTANCE = "editor:substance",
  VIEWER_SUBSTANCE = "viewer:substance",
}
